export const needsIdentityVerification = (userData, incodeEnabled) => {
  return userData?.user?.cashouts_verified < 4 && Boolean(incodeEnabled)
}
